module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-32.79ec7cf2.png";